export const useGooglePicker = (
  map: Ref<google.maps.Map | undefined>,
  readOnly: Ref<boolean | undefined>,
  picker: Ref<boolean | undefined>,
  pickerLocation: Ref<LatLngAlt | undefined>,
) => {
  const initializePicker = () => {
    if (!map.value) {
      throw new Error("Map is not initialized")
    }

    map.value.addListener("click", async (e: { latLng: google.maps.LatLng }) => {
      if (!map.value) return
      if (!picker.value) return
      if (readOnly.value) return

      pickerLocation.value = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      }
    })
  }

  return {
    initializePicker,
  }
}
